import {isString, isArray, isNil} from 'lodash'
import { WEIGHT_OZT_MAX, WEIGHT_OZT_MIN, PERCENT_MAX, PERCENT_MIN } from '@/util/refinery/constants'
import orderMixin from "@/mixins/order"

const stringRequired = (v) =>
  (isString(v) && v !== '') || 'This field is required.'

const arrayRequired = (v) =>
  (isArray(v) && v.length > 0) || 'Must select at least 1 value.'

const validateEmail = (v) => {
  // Test whether v is a valid email address. If not, return string indicating validation error.
  // If v is empty, return true (indicating no error), since this field is not required.
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return v ? emailRegex.test(v) || 'Must be a valid email' : true
}

const taxIdDigitLength = (v) =>
  v ? String(v).length === 9 || 'Tax ID Number must be 9 digits.' : true

const stateTaxIdAlphanumeric = v =>
  v ? /^[a-zA-Z0-9-]*$/.test(v) || 'State Tax ID must be alphanumeric.' : true

const termsAndConditions = (v) => {
  return v === true || 'You must accept the Terms and Conditions'
}

const greaterThanZero = v => isNil(v) || ((typeof v === 'number' ? v : Number(v.replace(/,/gu, ''))) > 0) || 'Must be > 0'

// Reusable clamping/limit rules
const maxOztRule = v => {
  if (v === null || v === undefined || v === '') return true
  const n = parseFloat(String(v).toString().replace(/[^0-9.-]/g, ''))
  return (isNaN(n) || n <= WEIGHT_OZT_MAX) || `Maximum allowed is ${WEIGHT_OZT_MAX.toLocaleString()} ozt`
}

const minOztRule = v => {
  if (v === null || v === undefined || v === '') return true
  const n = parseFloat(String(v).toString().replace(/[^0-9.-]/g, ''))
  return (isNaN(n) || n >= WEIGHT_OZT_MIN) || `Minimum allowed is ${WEIGHT_OZT_MIN} ozt`
}

const percentBoundsRule = v => {
  if (v === null || v === undefined || v === '') return true
  const n = parseFloat(v)
  if (isNaN(n)) return 'Invalid percent'
  if (n > PERCENT_MAX) return `Must be ≤ ${PERCENT_MAX}%`
  if (n < PERCENT_MIN) return `Must be ≥ ${PERCENT_MIN}%`
  return true
}

export default {
  data() {
    return {
      stringRequired,
      arrayRequired,
      greaterThanZero,
      maxOztRule,
      minOztRule,
      percentBoundsRule,
      emailRules: [validateEmail],
      companyNameRules: [stringRequired],
      vendorTaxIdRules: [stringRequired, taxIdDigitLength],
      vendorStateTaxIdRules: [stateTaxIdAlphanumeric],
      taxNumberTypeRules: [stringRequired],
      dateOfIncorporationRules: [stringRequired],
      countryOfIncorporation: [stringRequired],
      compInfoEmail: [validateEmail],
      //TODO: Needs to be rebuilt fullstack
      businessTypeRules: [],
      organizationTypeRules: [stringRequired],
      addr1Rules: [stringRequired],
      cityRules: [stringRequired],
      zipRules: [stringRequired],
      countryRules: [stringRequired],
      termsAndConditionsRules: [termsAndConditions],
      validateDepoFields() {
        this.$refs.standardDepoAttnName.validate()
        this.$refs.standardDepoAccountNumber.validate()
      },
      depoRules() {
        return [
          () => {
            return `${this.standardDepoAttnName}${orderMixin.data().DEPO_ATTENTION_DELIM}${this.standardDepoAccountNumber}`.length <= orderMixin.data().ADDRESS_CHAR_LIMIT
              || `Combined length of Account Holder Name and Account Number must be less than ${orderMixin.data().ADDRESS_CHAR_LIMIT - orderMixin.data().DEPO_ATTENTION_DELIM.length} characters`
          }
        ]
      },
      urlRules: [
        (v) =>
          v
            ? /https?:\/\/.+/.test(v) ||
            'Url must begin with http:// or https:// and have a domain.'
            : true,
      ],
    }
  }
}
